export default "__VITE_ASSET__B$OHeGL4__";